export function getJobTitle(job) {
  if (!job) {
    return "No Job Data";
  }
  const propStreetName = job.propertyStreet || "No Name";
  const propAddress = job.propertyAddress || "No Address";
  const numericPartOfAtmId = Number(job.atmId?.toString().match(/\d+/)[0])
    .toString()
    .padStart(5, "0");
  const currentYear = new Date(job.createdAt).getFullYear();
  return `${currentYear
    .toString()
    .slice(2)}-${numericPartOfAtmId}-${propStreetName}-${propAddress}`;
}

export const calculatePaymentAmount = (startDateTime, endDateTime, rate) => {
  const duration =
    new Date(endDateTime || Date.now()) - new Date(startDateTime);
  const durationToHours = duration / (1000 * 60 * 60);
  return durationToHours * (rate || 0);
};
